<template>
    <div>
        <avue-crud :data="data" :option="option" >
            <template slot-scope="scope" slot="menu">
                <el-button  class="View">查看</el-button>
                <el-button  class="View">下载</el-button>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    export default {
        name: "evidenceList",
        data() {
            return {
                data: [
                    {
                        type:'业务合同',
                        name:'信用卡申请表',
                        time:'2022.05.15 15:23:21'
                    }, {
                        type:'业务合同',
                        name:'银行主借款合同',
                        time:'2022.08.15 14:20:11'

                    }
                ],
                option:{
                    addBtn:false, //新增按钮
                    menuWidth:380,//操作栏宽度设置
                    columnBtn:false, //列动态显隐按钮
                    refreshBtn:false, // 刷新按钮
                    delBtn:false, // 行内删除按钮
                    editBtn:false, // 行内编辑按钮
                    stripe:true,
                    column:[
                        {
                            label:'合同类型',
                            prop:'type'
                        }, {
                            label:'证据名称',
                            prop:'name'
                        }, {
                            label:'导入时间',
                            prop:'time'
                        }
                    ]
                },
            };
        }
    }
</script>

<style scoped>
    .View{
        background-color: #3d62f6;
        color: #fff;
    }
    /deep/.cell{
        font-size: 14px;
    }
</style>
